<template>
<div class="draftbox">
  <div class="draftbox--header">
    <div class="draftbox--header--title">
      <div class="title--back iconfont" @click="$router.push('/')">&#xe600;</div>
      <div class="title--desc">草稿箱</div>
      <div class="title--add iconfont"></div>
    </div>
  </div>
  <div class="draftbox--line"></div>
  <div class="draftbox--card" @click="handleToEditorFollowRecord(item)" v-for="item in draftList" :key="item.id">
    <div class="desc--text">
      <div class="desc--company">{{item.cusName}}</div>
      <div class="desc--address">{{item.visitDate}} {{item.address}}</div>
      <div class="desc--status">已保存为草稿，请完善后提交。</div>
    </div>
    <div class="desc--icon iconfont">&#xe62c;</div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import recordPageTime from '../mixin/minin'
export default {
  name: 'DraftBox',
  data () {
    return {
      draftList: []
    }
  },
  beforeMount () {
    console.log(this.$route.params)
    this.draftList = this.$route.params.data
  },
  methods: {
    // 修改跟进记录日志
    handleToEditorFollowRecord (item) {
      this.$router.push({ name: 'addfollowup', params: { item } })
    }
  },
  mixins: [recordPageTime]
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.draftbox
  position : relative
  width : 100vw
  height : 100vh
  overflow-x : hidden
  background-color : #ffffff
  overflow-y : scroll
  &.active
    padding-bottom : 64px
  .draftbox--header
    position : fixed
    top:0
    left :0
    width : 100%
    z-index : 10
    .draftbox--header--title
      display : flex
      align-items : center
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding : 16px 0 16px 16px
      .title--add
        width : 100px
        font-size: 38px
        padding : 16px 16px 16px 0
        text-align : right
      .title--desc
        flex : 1
        padding : 16px 0
        text-align : center
  .draftbox--line
    width : 100%
    height : 78px
  .draftbox--card
    margin : 16px 16px 0 16px
    padding : 16px
    border-radius : 16px
    border : 1px solid #aca9a9
    display : flex
    align-items : center
    .desc--text
      flex : 1
      font-family: MyriadPro-Regular
      font-size: 26px
      font-weight: normal
      font-stretch: normal
      color: #333333
      overflow : hidden
      .desc--company
        width : 100%
        font-size: 34px
        padding-bottom : 8px
        color : #33333
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
      .desc--address
        width : 100%
        color : #33333
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
      .desc--status
        margin-top : 8px
        font-size : 32px
        color : #333333
    .desc--icon
      width : 80px
      text-align : right
      color : #333333
</style>
